import { useState } from 'react';
import { Send } from 'lucide-react';
import { AuthGate } from '../components/AuthGate';
import { useAuth } from '../lib/auth';
import { submitCreation } from '../lib/firestore';

const formats = ['Micro drama', 'Anime short', 'Vertical reel', 'Full series pitch'];
const genres = ['Action', 'Romance', 'Thriller', 'Comedy', 'Fantasy', 'Mystery'];

export function CreatePage() {
  const { user, profile } = useAuth();
  const [title, setTitle] = useState('');
  const [logline, setLogline] = useState('');
  const [genre, setGenre] = useState(genres[0]);
  const [format, setFormat] = useState(formats[0]);
  const [referenceUrl, setReferenceUrl] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [saved, setSaved] = useState(false);

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    if (!user) return;
    setSubmitting(true);
    try {
      await submitCreation({
        uid: user.uid,
        email: user.email || '',
        displayName: profile?.displayName || user.displayName || '',
        title,
        logline,
        genre,
        format,
        referenceUrl,
      });
      setSaved(true);
      setTitle('');
      setLogline('');
      setReferenceUrl('');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="page-pad">
      <AuthGate title="Login to submit a show idea">
        <section className="creator-page">
          <div className="section-heading">
            <p className="eyebrow">Create</p>
            <h1>Pitch a story built for fast obsession.</h1>
          </div>
          {saved && <div className="success-banner">Submission received. Admin review can update its status.</div>}
          <form className="stack-form" onSubmit={submit}>
            <label>
              <span>Title</span>
              <input value={title} onChange={(event) => setTitle(event.target.value)} required maxLength={80} />
            </label>
            <label>
              <span>Logline</span>
              <textarea value={logline} onChange={(event) => setLogline(event.target.value)} required rows={5} maxLength={500} />
            </label>
            <div className="split-fields">
              <label>
                <span>Genre</span>
                <select value={genre} onChange={(event) => setGenre(event.target.value)}>
                  {genres.map((item) => <option key={item}>{item}</option>)}
                </select>
              </label>
              <label>
                <span>Format</span>
                <select value={format} onChange={(event) => setFormat(event.target.value)}>
                  {formats.map((item) => <option key={item}>{item}</option>)}
                </select>
              </label>
            </div>
            <label>
              <span>Reference link</span>
              <input value={referenceUrl} onChange={(event) => setReferenceUrl(event.target.value)} type="url" placeholder="https://..." />
            </label>
            <button className="primary-action" type="submit" disabled={submitting}>
              <Send size={18} aria-hidden="true" />
              {submitting ? 'Submitting...' : 'Submit for review'}
            </button>
          </form>
        </section>
      </AuthGate>
    </div>
  );
}
